import React from "react";
import { useLocation } from "react-router-dom";
import { useStateMachine } from "little-state-machine";
import PropTypes from "prop-types";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { getStepFromPath } from "../lib/form/step";
import { updateStore } from "../lib/store";

function Button({ variant, methods, labelValidStep, labelNextStep }) {
  const {
    formState: { isSubmitting },
  } = methods;
  const location = useLocation();
  const { state } = useStateMachine({ updateStore });

  const activeStep = getStepFromPath(location.pathname);
  const statusSteps = state.statusSteps;

  const loading = isSubmitting
    ? { loading: true, loadingPosition: "start", startIcon: <SaveIcon /> }
    : { loading: false };

  return (
    <React.Fragment>
      <LoadingButton
        color="primary"
        type="submit"
        variant={variant}
        key={new Date()}
        {...loading}
      >
        {activeStep === statusSteps.length - 1 ? labelValidStep : labelNextStep}
      </LoadingButton>
    </React.Fragment>
  );
}

Button.defaultProps = {
  name: "button",
  variant: "contained",
  labelValidStep: "Valider",
  labelNextStep: "Suivant",
};

Button.propTypes = {
  /**
   * methods du useForm()
   */
  methods: PropTypes.instanceOf(Object),
  /**
   * The variant to use
   * 'filled'
   * | 'outlined'
   * | 'standard'
   */
  variant: PropTypes.string,
};

export default Button;
